export default __webpack_public_path__ + "static/botella_1-9dec3941befd4cc0e0ce30660fa7331e.jpg";